import React, { useState, useEffect } from "react";
import styles from "./scss/campaign.module.scss";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import LeftMenus from "./leftmenu";
import UserLeftMenus from "./userleftmenu";
import Headers from "./header";
import Cookies from "universal-cookie";
import arrows from "../styles/images/dropdownarrowwhite.svg";
import { useSelector, useDispatch } from "react-redux";
import { updateUserType } from "../store/login";
import { useNavigate } from "react-router-dom";
import HeadersMobile from "./mobileheader";
import { PARENT_ID, PRODUCT_ID, ULR_SITE } from "../service/constant";
const cookies = new Cookies();

type props = {
  children: any;
};
const LayoutMain = ({ children }: props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = useSelector((state: any) => state.login.login);
  const addonGetList = useSelector((state: any) => state.login.addonGetList);
  const emailAddon = addonGetList.map((addon)=>{
    return addon?.addon_id;
  })
  console.log("addonGetList",addonGetList,([677,678,679].includes( (addonGetList.filter(addon =>addon?.addon_id == 677)))))
  const product = useSelector((state: any) => state.constant.products);
  console.log("product", product);
  const usertype = useSelector((state: any) => state.login.userType);
  const [collapsemenu, setCollapseMenu] = useState(false);
  const [active, setActive] = useState("");
  console.log("active", active);
  const menucollapse = () => {
    setCollapseMenu(!collapsemenu);
  };
  useEffect(() => {
    //console.log("user left ", usertype);
    if (!cookies.get("ssoToken")) {
      //window.location.href = "/";
      //return;
    }
  }, []);

  console.log("condition",((product[0].parent_id  == PARENT_ID.XAIA3 ||
    product[0].parent_id  == PARENT_ID.LUKAS 
    // product[0].plan_id == "120" ||
    // product[0].plan_id == "121" ||
    // product[0].plan_id == "127" ||
    // product[0].plan_id == "128"
    || (emailAddon.includes(676) || emailAddon.includes(729))
  ) &&
  (login.v_org_role_id == 3 || login.v_org_role_id == 7)))
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1199);
  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth < 1200;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  useEffect(() => {
    console.log("window.location.pathname", window.location.pathname);
    let urlCheck =
      window.location.pathname == "/profile" ||
      window.location.pathname == "/numbersanddevices" ||
      window.location.pathname == "/linkedaccounts" ||
      window.location.pathname == "/callhandling-and-forwarding" ||
      window.location.pathname == "/uservoicemail" ||
      window.location.pathname == "/usercalllogs";
    console.log("urlCheck", urlCheck);
    if (urlCheck) {
      dispatch(updateUserType("Employee"));
    } else {
      dispatch(updateUserType("Company"));
      if (
        login?.v_org_role_id !== 1 &&
        login?.v_org_role_id !== 2 &&
        login?.v_org_role_id !== 3
      ) {
        navigate("/profile");
        dispatch(updateUserType("Employee"));
      }
    }
  }, []);

  return (
    <>
      <div className="allinone" style={{display:'none'}}>
        <div className="allinonelogo">
          <svg
            width="114"
            height="26"
            viewBox="0 0 114 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.8855 4.73577V17.3682H17.1919V13.4661C17.1919 10.8523 15.0801 8.73134 12.4766 8.73134H8.59137V0H21.1702C23.7737 0 25.8855 2.11996 25.8855 4.73577Z"
              fill="#00E2A4"
            />
            <path
              d="M17.1919 17.3672V26L8.59546 17.3672H17.1919Z"
              fill="#00E2A4"
            />
            <path
              d="M17.1919 13.4651C17.1919 10.8503 15.0811 8.73035 12.4777 8.73035H8.59239L8.59546 8.73343H0V17.3662H8.59546V8.73445L17.1909 17.3672V13.4651H17.1919Z"
              fill="black"
            />
            <path
              d="M46.9985 5.39282L44.8315 13.2444L42.827 5.67822H39.3322L37.3277 13.2444L35.1198 5.39282H31.5146L35.7065 20.445H38.3795L41.0791 12.6951L43.7582 20.445H46.4516L50.6435 5.39282H46.9985ZM54.1823 10.1122C51.3059 10.1122 48.957 12.4713 48.957 15.3602C48.957 18.2491 51.3059 20.6083 54.1823 20.6083C57.0587 20.6083 59.4077 18.2491 59.4077 15.3602C59.4077 12.4713 57.0587 10.1122 54.1823 10.1122ZM54.1823 17.3128C53.109 17.3128 52.2381 16.4382 52.2381 15.3602C52.2381 14.2823 53.109 13.4076 54.1823 13.4076C55.2556 13.4076 56.1265 14.2823 56.1265 15.3602C56.1265 16.4382 55.2556 17.3128 54.1823 17.3128ZM81.6767 7.04054H78.3955V16.1528C78.3955 19.1227 79.894 20.444 82.5067 20.444H84.4304V17.1486H82.6079C82.0406 17.1486 81.6767 16.742 81.6767 16.1928V13.1417H84.5531V10.2733H81.6767V7.03951V7.04054ZM107.256 10.2744H104.501V10.7425C103.731 10.3349 102.922 10.1111 102.03 10.1111C99.1548 10.1111 96.8263 12.4498 96.8263 15.3387C96.8263 18.2275 99.1548 20.6072 102.03 20.6072C102.961 20.6072 103.772 20.3424 104.542 19.9553V20.444H107.891V17.4648H107.256V10.2744ZM102.11 17.3118C101.038 17.3118 100.186 16.4371 100.186 15.3387C100.186 14.2402 101.037 13.385 102.11 13.385C103.183 13.385 104.055 14.2597 104.055 15.3387C104.055 16.4176 103.184 17.3118 102.11 17.3118ZM113.271 17.1486C112.785 17.1486 112.541 16.8231 112.541 16.355V6.20693H108.625V9.18616H109.261V16.315C109.261 19.1833 110.293 20.444 113.17 20.444H113.959V17.1486H113.27H113.271ZM62.9372 10.7415V10.2733H59.791V13.2526H60.4268V20.443H63.667V14.5851C63.667 13.9147 64.2149 13.385 64.8824 13.385H66.2184V10.2733H64.7608C64.1321 10.2733 63.525 10.375 62.9372 10.7415ZM77.3785 10.2733H73.4901L70.7221 12.9785V6.20693H66.8072V9.18616H67.4419V20.444H70.7231V17.5356L71.3599 16.9155L73.9164 20.444H77.8855L73.5515 14.7083L77.3785 10.2744V10.2733ZM92.4504 16.1107C92.4504 16.7821 91.9035 17.3313 91.235 17.3313C90.5665 17.3313 90.0207 16.781 90.0207 16.1107V10.2733H86.1232V13.2526H86.761V16.1107C86.761 18.592 88.7655 20.6062 91.2361 20.6062C93.7067 20.6062 95.7122 18.592 95.7122 16.1107V10.2733H92.4514V16.1107H92.4504Z"
              fill="black"
            />
          </svg>
        </div>
        <div className="allinonemenu">
          <ul>
            <li
              className="allinoneactive"
              onClick={() => {
                setActive("myAccount");
                window.location.href = "https://myaccount.worktual.co.uk/";
              }}
            >
              <svg
                width="29"
                height="28"
                viewBox="0 0 29 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.369 19.214L16.3601 19.2203C16.4112 18.9183 16.444 18.6128 16.444 18.3038C16.444 17.9944 16.4126 17.6889 16.3617 17.3878L16.3684 17.3944L17.1351 16.3957L16.6693 15.2715L15.4219 15.1077L15.4214 15.1176C15.2443 14.8686 15.0505 14.6301 14.8316 14.4112C14.6123 14.1918 14.3734 13.9976 14.1238 13.8203H14.1356L13.9717 12.5721L12.8473 12.1064L11.8494 12.8729L11.857 12.8815C11.5555 12.8304 11.2494 12.7988 10.9392 12.7988C10.629 12.7988 10.3229 12.8319 10.02 12.8833L10.0294 12.874L9.03112 12.1073L7.90682 12.573L7.74319 13.8204L7.76202 13.8194C7.2504 14.1819 6.81283 14.6294 6.45432 15.1372L6.45701 15.1073L5.20885 15.2712L4.74309 16.3956L5.50958 17.3934L5.52923 17.3697C5.4236 17.9815 5.41647 18.6065 5.52104 19.2237L5.50934 19.2139L4.74274 20.2123L5.20815 21.3368L6.45584 21.5004L6.45526 21.485C6.6334 21.7361 6.82686 21.9766 7.04665 22.1962C7.26573 22.4153 7.50551 22.6084 7.75582 22.7862H7.74307L7.90694 24.0344L9.03088 24.5L10.029 23.7335L10.014 23.7211C10.6324 23.8265 11.2583 23.8196 11.8712 23.7139L11.8484 23.7333L12.8471 24.5L13.9716 24.0344L14.1352 22.7868L14.1047 22.7891C14.6121 22.4311 15.059 21.9942 15.4214 21.4837V21.5L16.6693 21.3362L17.1353 20.2119L16.369 19.214ZM14.4359 18.9993C14.2984 19.691 13.9587 20.3263 13.4602 20.825C12.9616 21.3235 12.3262 21.6632 11.6346 21.8008C10.9431 21.9381 10.2262 21.8676 9.57466 21.5978C8.92315 21.3279 8.36627 20.8708 7.97466 20.2844C7.58282 19.698 7.37369 19.0085 7.3738 18.3034C7.37497 17.3583 7.75091 16.4521 8.41926 15.7836C9.08761 15.1153 9.99399 14.7393 10.9392 14.7384C11.6443 14.7384 12.3336 14.9475 12.92 15.3392C13.5064 15.731 13.9634 16.2879 14.2332 16.9394C14.5031 17.5909 14.5736 18.3078 14.4359 18.9993Z"
                  fill="#00DEA0"
                />
                <path
                  d="M10.9387 19.896C11.8183 19.896 12.5313 19.1829 12.5313 18.3033C12.5313 17.4237 11.8183 16.7107 10.9387 16.7107C10.0591 16.7107 9.34604 17.4237 9.34604 18.3033C9.34604 19.1829 10.0591 19.896 10.9387 19.896Z"
                  fill="#00DEA0"
                />
                <path
                  d="M24.2662 11.9899L24.2558 11.9973C24.3166 11.6365 24.356 11.2717 24.356 10.9025C24.356 10.5329 24.3184 10.1681 24.2576 9.80841L24.2657 9.81613L25.1814 8.62341L24.6251 7.28063L23.1347 7.08494L23.1341 7.09687C22.9231 6.79942 22.6915 6.51449 22.4302 6.25307C22.1682 5.99094 21.8828 5.759 21.5844 5.54729H21.5987L21.4031 4.05642L20.0598 3.50012L18.868 4.41563L18.8771 4.42604C18.5167 4.36498 18.1512 4.32732 17.7806 4.32732C17.4106 4.32732 17.0449 4.36685 16.683 4.42814L16.6942 4.41703L15.5015 3.50141L14.1585 4.05759L13.9631 5.54764L13.9854 5.54647C13.3746 5.97936 12.8519 6.51391 12.4237 7.1205L12.4268 7.08482L10.9358 7.28051L10.3795 8.62365L11.2951 9.81555L11.3184 9.78712C11.2138 10.3929 11.2122 11.0087 11.2781 11.6218C11.3642 11.6112 11.4947 11.5702 11.5687 11.555L12.7036 11.289L13.5363 11.1015C13.5335 11.0348 13.5217 10.9692 13.5217 10.9023C13.523 9.77344 13.9721 8.6909 14.7703 7.89248C15.5689 7.09418 16.6514 6.64526 17.7801 6.64397C18.6227 6.64397 19.4459 6.8937 20.1462 7.36169C20.8463 7.82956 21.3923 8.49475 21.7148 9.27293C22.037 10.0511 22.1211 10.9074 21.9569 11.7335C21.7927 12.5597 21.3872 13.3184 20.7913 13.9142C20.1957 14.5096 19.4371 14.9152 18.611 15.0797C18.3791 15.1258 18.2641 15.1472 18.0295 15.1543L17.9393 17.4608C18.2989 17.4569 18.4923 17.4395 18.8523 17.3905L18.8664 17.3881L20.0594 18.3039L21.4024 17.7476L21.5977 16.2575L21.5615 16.2603C22.1672 15.8327 22.7013 15.3108 23.1337 14.701V14.7205L24.6247 14.5248L25.1813 13.182L24.2662 11.9899Z"
                  fill="black"
                />
                <path
                  d="M19.6827 10.9021C19.6827 9.85146 18.8309 8.99982 17.7803 8.99982C16.7297 8.99982 15.8781 9.85146 15.8781 10.9021C15.8781 11.9527 16.7297 12.8043 17.7803 12.8043C18.8309 12.8043 19.6827 11.9527 19.6827 10.9021Z"
                  fill="black"
                />
              </svg>
              My Account
            </li>
            {
              product[0].product_id == PRODUCT_ID.CHATBOT &&
                login.v_org_role_id !== 7 &&
                login.v_org_role_id !== 8 ? (
                // <li onClick={() => { setActive("contactCenter"); window.location.href = "http://localhost:3001" }}>
                <li
                  onClick={() => {
                    setActive("contactCenter");
                    window.location.href = ULR_SITE.CCAAS;
                  }}
                >
                  <svg
                    width="29"
                    height="28"
                    viewBox="0 0 29 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_672_6284)">
                      <path
                        d="M21.9617 7.93762V11.7639C22.5967 11.7102 23.0952 11.2385 23.0952 10.6576V9.04397C23.0952 8.46309 22.5967 7.99141 21.9617 7.93762Z"
                        fill="#00DEA0"
                      />
                      <path
                        d="M7.96044 7.93762V11.7639C7.32542 11.7102 6.8269 11.2385 6.8269 10.6576V9.04397C6.8269 8.46309 7.32542 7.99141 7.96044 7.93762Z"
                        fill="#00DEA0"
                      />
                      <path
                        d="M15.821 4.21097C15.8096 3.73532 15.4199 3.35767 14.946 3.35767H14.9243C14.4412 3.36968 14.0596 3.77125 14.071 4.25437L14.0995 5.4159C14.1109 5.89155 14.5006 6.2692 14.9745 6.2692H14.9962C15.4793 6.25718 15.8609 5.85562 15.8495 5.3725L15.821 4.21097Z"
                        fill="#00DEA0"
                      />
                      <path
                        d="M21.2957 16.1793H16.9127V16.1752H13.0049V16.1793H8.62193C7.44558 16.1793 6.49194 17.1329 6.49194 18.3092V19.4343H6.49883C6.54293 20.4494 6.82129 21.7227 7.96148 22.7631C9.16886 23.8647 11.2262 24.5965 14.6334 24.6402V24.6423H15.2845V24.6402C18.6917 24.5965 20.749 23.8647 21.9565 22.7631C23.0966 21.7227 23.3749 20.4494 23.4191 19.4343H23.426V18.3092C23.426 17.1329 22.472 16.1793 21.2957 16.1793Z"
                        fill="#00DEA0"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M21.4307 8.79962L21.433 8.89248C21.4409 9.216 21.4409 9.53508 21.4409 9.853C21.4472 10.12 21.4418 10.4072 21.4364 10.693C21.436 10.7146 21.4356 10.7361 21.4352 10.7576L21.4307 10.9074C21.4079 11.726 21.3726 12.9633 20.1763 13.7449C19.1179 14.4382 17.6959 14.5179 16.4472 14.5385C15.8958 14.5481 15.4252 14.5533 14.9547 14.5533C14.4832 14.5533 14.0137 14.5481 13.46 14.5385C12.2125 14.5179 10.7917 14.4381 9.73215 13.7449C8.53585 12.9628 8.5005 11.7242 8.47775 10.9051L8.47437 8.9136C8.5005 7.98785 8.53585 6.7506 9.73098 5.96275C10.7917 5.26823 12.2125 5.18855 13.4612 5.16802C14.5651 5.14923 15.3422 5.14923 16.4484 5.16802C17.6959 5.18855 19.1179 5.26835 20.1774 5.96158C21.3726 6.74372 21.4079 7.98097 21.4307 8.79962ZM11.4457 9.85073C11.4457 10.5245 11.9917 11.0706 12.6655 11.0706C13.3391 11.0706 13.8854 10.5244 13.8854 9.85073C13.8854 9.17709 13.3392 8.63086 12.6655 8.63086C11.9917 8.63086 11.4457 9.17698 11.4457 9.85073ZM16.0315 9.85073C16.0315 10.5245 16.5775 11.0706 17.2513 11.0706C17.9249 11.0706 18.4713 10.5244 18.4713 9.85073C18.4713 9.17709 17.925 8.63086 17.2513 8.63086C16.5775 8.63086 16.0315 9.17698 16.0315 9.85073Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_672_6284">
                        <rect
                          width="28"
                          height="28"
                          fill="white"
                          transform="translate(0.958984)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Chatbox
                </li>
              ) : product[0].product_id == PRODUCT_ID.CCAAS ? (
                <li
                  onClick={() => {
                    setActive("contactCenter");
                    window.location.href = ULR_SITE.CCAAS;
                  }}
                >
                  <svg
                    width="65"
                    height="64"
                    viewBox="0 0 65 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ width: "29px" }}
                  >
                    <g clip-path="url(#clip0_4226_241511)">
                      <path
                        d="M33.6962 25.0007H31.2962V38.9999H33.6962V25.0007Z"
                        fill="black"
                      />
                      <path
                        d="M37.7882 28.3801H35.3882V35.8403H37.7882V28.3801Z"
                        fill="black"
                      />
                      <path
                        d="M29.6039 28.3801H27.2039V35.8403H29.6039V28.3801Z"
                        fill="black"
                      />
                      <path
                        d="M25.5117 30.4824H23.1117V33.7402H25.5117V30.4824Z"
                        fill="black"
                      />
                      <path
                        d="M41.8758 30.4824H39.4758V33.7402H41.8758V30.4824Z"
                        fill="black"
                      />
                      <path
                        d="M32.4971 46.4623H18.0378V35.6003H8.79878C10.54 47.1427 20.4719 56.0003 32.5 56.0003C44.5281 56.0003 54.46 47.1427 56.2012 35.6003H46.4915C44.8878 41.8425 39.2389 46.4623 32.4971 46.4623Z"
                        fill="#00DEA0"
                      />
                      <path
                        d="M32.5065 17.5381C39.2471 17.5381 44.8936 22.1583 46.4934 28.4H56.2012C54.46 16.8577 44.5281 8 32.5 8C20.4719 8 10.54 16.8577 8.79878 28.4H18.5094C20.1141 22.1576 25.7629 17.5381 32.5065 17.5381Z"
                        fill="#00DEA0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4226_241511">
                        <rect
                          width="64"
                          height="64"
                          fill="white"
                          transform="translate(0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  AI Contact Centre
                </li>
              ) : (
                ""
              )
              // <li onClick={() => { setActive("Unified Communications"); window.location.href = 'https://app.worktual.co.uk/home' }}>
              // 						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              // 						<g clipPath="url(#clip0_571_97179)">
              // 					 <path d="M18.4004 14.607C17.4241 13.6307 15.8412 13.6307 14.8649 14.607L9.43201 20.0399L10.3143 20.9222C11.2906 21.8985 12.8735 21.8985 13.8498 20.9222L19.2827 15.4893L18.4004 14.607Z" fill="#00DEA0" />
              //                       <path d="M13.7326 3.07793C12.7563 2.10163 11.1734 2.10163 10.1971 3.07793L4.76416 8.51083L5.64646 9.39313C6.62276 10.3694 8.20566 10.3694 9.18196 9.39313L14.6149 3.96023L13.7326 3.07793Z" fill="#00DEA0" />
              //                       <path d="M3.89899 9.37598L3.05449 10.2205C2.07819 11.1968 2.07819 12.7797 3.05449 13.756L8.48739 19.1889L9.33189 18.3444C10.3082 17.3681 10.3082 15.7852 9.33189 14.8089L3.89899 9.37598Z" fill="#252526" />
              //                       <path d="M20.9455 10.2908L15.5126 4.85791L14.6681 5.70241C13.6918 6.67871 13.6918 8.26171 14.6681 9.23801L20.101 14.6709L20.9455 13.8264C21.9218 12.8501 21.9218 11.267 20.9455 10.2908Z" fill="#252526" />
              //                       <path d="M10.5199 11.2929L11.9999 9.81285L13.4799 11.2929C13.8702 11.6831 13.8702 12.3169 13.4799 12.7071L11.9999 14.1872L10.5199 12.7071C10.1296 12.3169 10.1296 11.6831 10.5199 11.2929Z" fill="#252526" />
              // 						</g>
              // 						<defs>
              // 							<clipPath id="clip0_571_97179">
              // 								<rect width="28" height="28" fill="white" />
              // 							</clipPath>
              // 						</defs>
              // 					</svg>
              // 					Unified Communications
              // 				</li>
            }
            <>
              {((
                product[0].parent_id  == PARENT_ID.LUKAS 
                // product[0].plan_id == "120" ||
                // product[0].plan_id == "121" ||
                // product[0].plan_id == "127" ||
                // product[0].plan_id == "128"
                || (emailAddon.includes(676) || emailAddon.includes(729))
              ) &&
              (login.v_org_role_id == 3 || login.v_org_role_id == 7))  ? (
                <>
                  <li
                    onClick={() => {
                      setActive("appointmentBooking");
                      window.location.href = ULR_SITE.BOOKING;
                    }}
                  >
                    <svg
                      width="29"
                      height="28"
                      viewBox="0 0 29 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.1513 8.34147C17.6964 8.34147 17.3274 7.97247 17.3274 7.51757V4.3239C17.3274 3.869 17.6964 3.5 18.1513 3.5C18.6062 3.5 18.9752 3.869 18.9752 4.3239V7.51757C18.9752 7.97247 18.6062 8.34147 18.1513 8.34147Z"
                        fill="#00E2A4"
                      />
                      <path
                        d="M11.766 8.34147C11.3111 8.34147 10.9421 7.97247 10.9421 7.51757V4.3239C10.9421 3.869 11.3111 3.5 11.766 3.5C12.2209 3.5 12.5899 3.869 12.5899 4.3239V7.51757C12.5899 7.97247 12.2209 8.34147 11.766 8.34147Z"
                        fill="#00E2A4"
                      />
                      <path
                        d="M22.9462 6.90953C21.5554 5.49077 19.5107 5.28216 17.6052 5.24041C16.7289 5.21954 15.8491 5.20911 14.9694 5.20911C14.0897 5.20911 13.2098 5.21954 12.3335 5.24041C10.428 5.29611 8.38341 5.49077 6.99233 6.90953C5.99233 7.91909 5.68848 9.37146 5.57983 10.799H24.3521C24.2456 9.37212 23.9391 7.92161 22.9462 6.90953Z"
                        fill="black"
                      />
                      <path
                        d="M24.4207 12.6959C24.4195 12.6153 24.4178 12.5292 24.4165 12.447H5.50992C5.50805 12.534 5.50607 12.6247 5.5042 12.7098C5.4763 14.1424 5.4763 15.5752 5.5042 17.0079C5.532 18.9135 5.532 21.3197 6.97844 22.7941C8.36941 24.213 10.414 24.4215 12.3196 24.4632C13.2571 24.4855 14.1948 24.4999 15.1323 24.4999C15.9476 24.4999 16.7623 24.4891 17.5773 24.4632C19.4829 24.4076 21.5276 24.213 22.9185 22.7941C24.3652 21.3197 24.3511 18.9135 24.393 17.0079C24.393 16.3541 24.4208 15.7142 24.4208 15.0606H24.4347C24.4347 14.2678 24.4346 13.4887 24.4207 12.6959ZM11.4631 20.3137C11.4631 20.4904 11.3197 20.6339 11.1429 20.6339H9.60318C9.4262 20.6339 9.28295 20.4904 9.28295 20.3137V18.7739C9.28295 18.5971 9.4262 18.4537 9.60318 18.4537H11.1429C11.3197 18.4537 11.4631 18.5971 11.4631 18.7739V20.3137ZM11.4631 16.3539C11.4631 16.5307 11.3197 16.6741 11.1429 16.6741H9.60318C9.4262 16.6741 9.28295 16.5307 9.28295 16.3539V14.8141C9.28295 14.6371 9.4262 14.4938 9.60318 14.4938H11.1429C11.3197 14.4938 11.4631 14.6371 11.4631 14.8141V16.3539ZM16.0716 20.3137C16.0716 20.4904 15.9281 20.6339 15.7515 20.6339H14.2116C14.0348 20.6339 13.8914 20.4904 13.8914 20.3137V18.7739C13.8914 18.5971 14.0348 18.4537 14.2116 18.4537H15.7515C15.9281 18.4537 16.0716 18.5971 16.0716 18.7739V20.3137ZM16.4782 15.02L15.3563 16.2909C15.1794 16.4927 14.9232 16.6062 14.6539 16.6046C14.6153 16.6044 14.5757 16.6015 14.5378 16.5964C14.3124 16.5657 14.1058 16.4528 13.9574 16.2767L13.5502 15.7948C13.3696 15.5819 13.3957 15.2623 13.6097 15.0818C13.8228 14.8999 14.1435 14.926 14.3225 15.1412L14.6645 15.5444L15.7186 14.3504C15.9046 14.1387 16.2236 14.1221 16.4332 14.3052C16.6426 14.4908 16.6627 14.8105 16.4782 15.02ZM20.6122 20.3137C20.6122 20.4904 20.4689 20.6339 20.2921 20.6339H18.7522C18.5755 20.6339 18.432 20.4904 18.432 20.3137V18.7739C18.432 18.5971 18.5755 18.4537 18.7522 18.4537H20.2921C20.4689 18.4537 20.6122 18.5971 20.6122 18.7739V20.3137ZM20.6122 16.3539C20.6122 16.5307 20.4689 16.6741 20.2921 16.6741H18.7522C18.5755 16.6741 18.432 16.5307 18.432 16.3539V14.8141C18.432 14.6371 18.5755 14.4938 18.7522 14.4938H20.2921C20.4689 14.4938 20.6122 14.6371 20.6122 14.8141V16.3539Z"
                        fill="#00E2A4"
                      />
                    </svg>
                    Appointment Bookings
                  </li>
                </>
              ) : null}
              {((product[0].parent_id  == PARENT_ID.LUKAS 
                // product[0].plan_id == "120" ||
                // product[0].plan_id == "121" ||
                // product[0].plan_id == "127" ||
                // product[0].plan_id == "128"
                || (emailAddon.includes(677)) || (emailAddon.includes(678)) || (emailAddon.includes(679))
              ) &&
              (login.v_org_role_id == 3 || login.v_org_role_id == 8) )  ? (
                <>
                  <li
                    onClick={() => {
                      setActive("emailMarketing");
                      window.location.href =
                        ULR_SITE.MARKETING;
                    }}
                  >
                    <svg
                      width="29"
                      height="28"
                      viewBox="0 0 29 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_646_90)">
                        <path
                          d="M25.8872 15.6582C25.5031 14.7798 24.7733 14.155 23.9289 13.8792L25.8615 18.2972C26.235 17.4965 26.2714 16.5366 25.8872 15.6582Z"
                          fill="black"
                        />
                        <path
                          d="M25.6746 20.2636L22.2153 12.1352C22.0783 11.8609 21.7657 11.5386 21.3375 11.5332C20.9068 11.5274 20.5314 11.825 20.216 12.4175C20.1551 12.5322 20.0908 12.6597 20.022 12.7977C19.6139 13.6147 19.0367 14.7495 17.7513 15.6591L20.0486 21.0604C21.5969 20.7614 22.8142 21.1433 23.6867 21.4154C23.8347 21.4618 23.9718 21.5048 24.0968 21.5401C24.5516 21.6692 24.9222 21.6748 25.204 21.5577C25.3222 21.5085 25.4246 21.4382 25.5111 21.3461C25.8044 21.034 25.789 20.585 25.6746 20.2636Z"
                          fill="black"
                        />
                        <path
                          d="M15.0132 9.92033L24.047 4.21285C23.4955 3.77336 22.8063 3.5 22.0463 3.5H6.98883C6.20788 3.5 5.50146 3.78839 4.9433 4.24994L14.0234 9.92355C14.3248 10.1116 14.7136 10.1106 15.0132 9.92033Z"
                          fill="#00E2A4"
                        />
                        <path
                          d="M13.1845 20.2923C12.9284 19.7193 12.5044 18.77 12.9411 17.6787C13.3324 16.705 14.2293 15.9946 15.9414 15.3015C16.1266 15.2246 16.2617 15.1524 16.3967 15.0826L16.7919 14.8769L17.063 14.6854C18.1229 13.9353 18.6039 12.9698 18.9556 12.2651C19.0301 12.1137 19.1012 11.9751 19.1675 11.8504C19.8314 10.6042 20.7084 10.341 21.3258 10.341C22.1492 10.3503 22.9075 10.8465 23.2836 11.6058L23.6828 12.5433L24.3028 12.746C24.6504 12.8596 24.9716 13.0252 25.2759 13.2168V6.72749C25.2759 6.29253 25.1872 5.87891 25.0311 5.50012L15.8776 11.284C15.4653 11.5457 14.9919 11.676 14.5181 11.676C14.049 11.676 13.5799 11.5477 13.1696 11.2914L3.99056 5.55594C3.84816 5.91994 3.76312 6.31292 3.76312 6.72761V17.4865C3.76312 19.2693 5.20827 20.7142 6.99082 20.7142H13.3708L13.3592 20.6859L13.1845 20.2923Z"
                          fill="#00E2A4"
                        />
                        <path
                          d="M18.5682 21.5288C18.7837 21.4323 18.9896 21.3614 19.1949 21.2917L16.9926 16.1142C16.8113 16.2088 16.632 16.3043 16.4276 16.3892C16.4139 16.3949 16.3993 16.4009 16.3849 16.407C15.0126 16.9618 14.2999 17.4859 14.0457 18.122C13.7958 18.7443 14.0466 19.3048 14.2682 19.7996C14.3125 19.899 14.3581 20.0011 14.4121 20.1312L14.4631 20.2447L14.5228 20.3941C14.5693 20.4981 14.6107 20.6017 14.6519 20.7025C14.8545 21.2052 15.085 21.7749 15.7064 22.0267C16.0207 22.1541 16.3905 22.1801 16.8481 22.1022C16.8551 22.1232 16.852 22.1449 16.8605 22.1655L17.5971 23.9389C17.7311 24.2609 18.0283 24.4653 18.3534 24.496C18.4964 24.5095 18.6455 24.4892 18.7875 24.4305C19.2515 24.2378 19.4718 23.7048 19.2791 23.2401L18.5682 21.5288Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_646_90">
                          <rect
                            width="28"
                            height="28"
                            fill="white"
                            transform="translate(0.958984)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Email Marketing
                  </li>
                </>
              ) : null}
            </>
            {/* <>
              {((product[0].product_id == "15" ||
                product[0].product_id == "1")) || (emailAddon.includes(669)) && (
                <>
                  <li
                    onClick={() => {
                      window.location.href = "https://tickets.worktual.co.uk/";
                    }}
                  >
                    <svg
                      width="24"
                      height="22"
                      viewBox="0 0 24 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.285 4.52359C15.2319 4.34986 15.331 4.16591 15.5047 4.11277C15.6785 4.05963 15.8624 4.15876 15.9155 4.33249L16.2201 5.33296C16.2732
5.50669 16.1741 5.69065 16.0004 5.74378C15.8266 5.79692 15.6427 5.69779 15.5896 5.52407L15.285 4.52359ZM16.0944 7.18267C16.0821 7.14383 16.078 7.10398 16.0811 7.06616C16.0893 6.93331 16.1792 6.81272 16.3141 6.77185C16.4878 6.71871 16.6718 6.81783 16.7249 6.99156L16.7576
7.09887L17.0295 7.99205C17.0826 8.16578 16.9835 8.34974 16.8098 8.40287C16.636 8.45601 16.4521 8.35688 16.3989 8.18315L16.0944 7.18267ZM22.8483 8.29148C22.3424 8.26184 21.8591 8.08811 21.4544 7.79992C21.2571 7.65992 21.0783 7.49129 20.924 7.30018C20.7166 7.04163
20.553 6.74017 20.4508 6.40292C20.272 5.81632 20.3057 5.21643 20.506 4.68503C20.6818 4.21904 20.9863 3.80514 21.39 3.49959L20.4447 0.391846L15.2032 1.98711L15.4117 2.67283C15.4648 2.84656 15.3657 3.03051 15.192 3.08365C15.0182 3.13679 14.8343 3.03766 14.7812
2.86393L14.5727 2.17923L0.929874 6.33135L0.606934 6.42946L1.45821 9.22562H21.3963C21.5792 9.22562 21.7274 9.3738 21.7274 9.55672V12.0308L23.7958 11.4013L22.8495 8.29254L22.8483 8.29148Z"
                        fill="black"
                      />

                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.718 12.5527C14.718 12.3697 14.8662 12.2216 15.0491 12.2216C15.232 12.2216 15.3802 12.3697 15.3802 12.5527V13.5981C15.3802 13.781
15.232 13.9292 15.0491 13.9292C14.8662 13.9292 14.718 13.781 14.718 13.5981V12.5527ZM14.718 15.3323C14.718 15.1494 14.8662 15.0012 15.0491 15.0012C15.232 15.0012 15.3802 15.1494 15.3802 15.3323V16.3778C15.3802 16.5607 15.232 16.7089 15.0491 16.7089C14.8662
16.7089 14.718 16.5607 14.718 16.3778V15.3323ZM14.718 18.112C14.718 17.9291 14.8662 17.7809 15.0491 17.7809C15.232 17.7809 15.3802 17.9291 15.3802 18.112V19.1575C15.3802 19.3404 15.232 19.4886 15.0491 19.4886C14.8662 19.4886 14.718 19.3404 14.718 19.1575V18.112ZM20.8561
18.3597C20.8559 18.3595 20.8556 18.3593 20.8553 18.3592C20.3803 18.1834 19.9696 17.8769 19.6662 17.4835C19.3177 17.0318 19.1113 16.4667 19.1113 15.8546C19.1113 15.2424 19.3188 14.6773 19.6662 14.2256C19.8575 13.9776 20.0915 13.7641 20.3573 13.5961C20.6403
13.4173 20.8558 13.1275 20.8558 12.7927V10.9021C20.8558 10.4602 20.4976 10.1021 20.0558 10.1021H16.0934C15.6989 10.1021 15.3791 10.4219 15.3791 10.8164C15.3791 10.9993 15.2309 11.1475 15.048 11.1475C14.865 11.1475 14.7169 10.9993 14.7169 10.8164C14.7169 10.4219
14.397 10.1021 14.0025 10.1021L0.922503 10.103C0.480697 10.103 0.122559 10.4612 0.122559 10.903V12.7937C0.122559 13.1285 0.338031 13.4183 0.621048 13.5972C0.886861 13.7651 1.12079 13.9786 1.3121 14.2266C1.66058 14.6783 1.86702 15.2434 1.86702 15.8556C1.86702
16.4677 1.65957 17.0329 1.3121 17.4846C1.12079 17.7326 0.886857 17.946 0.621042 18.114C0.338027 18.2928 0.122559 18.5827 0.122559 18.9174V20.8081C0.122559 21.2499 0.480731 21.6081 0.922559 21.6081H14.0036C14.3981 21.6081 14.7179 21.2883 14.7179 20.8938C14.7179
20.7108 14.8661 20.5627 15.049 20.5627C15.2319 20.5627 15.3801 20.7108 15.3801 20.8938C15.3801 21.2883 15.6999 21.6081 16.0945 21.6081H20.0568C20.4986 21.6081 20.8568 21.2499 20.8568 20.8081V18.3614C20.8568 18.3607 20.8566 18.3601 20.8561 18.3597Z"
                        fill="#00DEA0"
                      />
                    </svg>
                    Ticketing
                  </li>
                </>
              )}
            </> */}
          </ul>
        </div>
      </div>
      {/* {!isMobile ? (
        <Row
          className={
            collapsemenu
              ? `${styles.maindiv} maindivcolumn`
              : `${styles.maindiv}`
          }
        >
          <Col
            sm={3}
            className={collapsemenu ? "leftcolumnmenu" : `${styles.leftcolumn}`}
          >
            {usertype == "Company" ? (
              <LeftMenus></LeftMenus>
            ) : (
              <UserLeftMenus></UserLeftMenus>
            )}
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip>
                  {collapsemenu ? "Click to Expand" : "Click to collapse"}
                </Tooltip>
              }
            >
              <p
                className={
                  collapsemenu
                    ? "collapsesidebarmini"
                    : `${styles.collapsesidebar}`
                }
                onClick={menucollapse}
              >
                <img
                  src={arrows}
                  alt={collapsemenu ? "Click to Expand" : "Click to collapse"}
                />
              </p>
            </OverlayTrigger>
          </Col>
          <Col
            sm={9}
            className={
              collapsemenu ? "centercolumnmenu" : `${styles.centercolumn}`
            }
          >
            <Headers></Headers>
            <div className={styles.maincontent}>{children}</div>
          </Col>
        </Row>
      ) : ( */}
      <div className={collapsemenu
        ? `${styles.maindiv}`
        : `${styles.maindiv} maindivcolumn`}>
        <div className={collapsemenu ? `${styles.leftcolumn}` : "leftcolumnmenu"}>
          {usertype == "Company" ? (
            <LeftMenus></LeftMenus>
          ) : (
            <UserLeftMenus></UserLeftMenus>
          )}
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>
                {collapsemenu ? "Click to Expand" : "Click to collapse"}
              </Tooltip>
            }
          >
            <p
              className={
                collapsemenu
                  ?
                  `${styles.collapsesidebar}` : "collapsesidebarmini"
              }
              onClick={menucollapse}
            >
              <img
                src={arrows}
                alt={collapsemenu ? "Click to Expand" : "Click to collapse"}
              />
            </p>
          </OverlayTrigger>
        </div>
        <div className={collapsemenu ? "centercolumnmenu leftmaincolumn" : `${styles.centercolumn}`}>
          {!isMobile ? <Headers /> : <HeadersMobile />}
          <div className={styles.maincontent}>{children}</div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};
export default LayoutMain;
